import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/pro-2.jpg";
import { ArrowRightCircle } from "react-bootstrap-icons";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { Counter } from "./Counter";
import cvFile from "../assets/file/yasiru_cv.pdf";

const toRotate = [
  "Full-Stack Software Engineer",
  "SaaS Product Builder",
  "React & Node.js Specialist",
];

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(150);
  const period = 2000;

  const tick = useCallback(() => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(100);
    } else {
      setDelta(150);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  }, [loopNum, isDeleting, text.length, period]);

  useEffect(() => {
    let ticker = setTimeout(() => {
      tick();
    }, delta);

    return () => clearTimeout(ticker);
  }, [text, delta, tick]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h1 className="responsive-heading">
                    <span>Hi. I'm Yasiru Deshan.</span>
                    <br />
                    <span className="txt-rotate">
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  <p style={{ color: "rgb(212, 237, 228)" }}>
                    Full-Stack Software Engineer with 3+ years of experience
                    building production SaaS products. I've shipped AI features
                    with measurable adoption, built a veterinary SaaS platform
                    solo from client requirements to deployment, and published
                    research at IEEE ICAIBD 2023.
                  </p>

                  <div className="banner-cta-buttons">
                    <a href="#featured-project" className="cta-btn primary-btn">
                      View My Work <ArrowRightCircle size={25} />
                    </a>
                    <a
                      href={cvFile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cta-btn secondary-btn"
                      download="Yasiru_Deshan_CV.pdf"
                    >
                      Download CV
                    </a>
                  </div>

                  <div className="banner-stats">
                    <div className="stat-item">
                      <Counter end="3" suffix="+" />
                      <span className="stat-label">Years Experience</span>
                    </div>
                    <div className="stat-item">
                      <Counter end="10" suffix="+" />
                      <span className="stat-label">Projects Shipped</span>
                    </div>
                    <div className="stat-item">
                      <Counter end="3" suffix="+ Countries" />
                      <span className="stat-label">Global Work Experience</span>
                    </div>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col
            xs={12}
            md={6}
            xl={5}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrackVisibility className="track-visibility-container">
              {({ isVisible }) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "80%",
                    maxWidth: "350px",
                    aspectRatio: "1 / 1",
                    borderRadius: "50%",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <img
                    src={headerImg}
                    alt="Header Img"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
